import React, { Component } from "react";
import { connect } from "react-redux";

import Link from "next/link";
import { buildUrl } from "../../config/utils";

// Bug conocido de Next.js 9 + CSS modules en dev mode:
// - <Link> hace client-side routing → fetchea HTML + reusa el bundle
//   CSS cacheado del browser.
// - Si los hashes del CSS module (style__abc123) cambiaron entre el
//   bundle cacheado y el HTML nuevo (HMR partial, edit del page, etc),
//   los classNames no matchean → página renderea SIN estilos.
// - El usuario tiene que hacer Ctrl+Shift+R para sincronizar.
//
// Workaround: en dev usar <a href> plano (full page reload). Pérdida
// de SPA feel marginal en dev — bug visible CERO. En prod (NODE_ENV=
// production) los hashes son estables, así que mantenemos <Link>.
const IS_DEV = process.env.NODE_ENV !== "production";

class CreateLink extends Component {
    render() {
        const { children, href } = this.props;
        const url = buildUrl(href);

        if (IS_DEV) {
            // Render children directamente con href forzado para que el
            // browser haga full page reload. cloneElement preserva todos
            // los props del <a> child (className, FontAwesome icons, etc).
            return React.cloneElement(children, {
                href: url.as || url.href
            });
        }

        return (
            <Link href={url.href} as={url.as}>
                {children}
            </Link>
        );
    }
}

export default connect()(CreateLink);
